import { CAlert, CFormLabel } from '@coreui/react'
import React, { useId } from 'react'
import { isLabelValid } from '@companion-app/shared/Label.js'
import { TextInputField } from '~/Components/TextInputField.js'

interface ImageNameInputProps {
	value: string
	onChange: (value: string) => void
	disabled?: boolean
	placeholder?: string
	helpText?: string | React.ReactNode
	showWarning?: boolean
	warningText?: string | React.ReactNode
	errorMessage?: string | null
}

export function ImageNameInput({
	value,
	onChange,
	disabled = false,
	placeholder = 'Enter image name...',
	helpText,
	showWarning = false,
	warningText,
	errorMessage,
}: ImageNameInputProps): JSX.Element {
	// Generate tooltip based on validation state
	const tooltip = !isLabelValid(value) ? 'Invalid name: Use only letters, numbers, hyphens, and underscores' : undefined

	const defaultHelpText = (
		<>
			The image name is used to reference this image in button configurations and other places.
			<br />
			It must contain only letters, numbers, hyphens, and underscores.
		</>
	)

	const labelInputId = useId()

	return (
		<>
			{errorMessage && (
				<CAlert color="danger" className="mb-3">
					{errorMessage}
				</CAlert>
			)}

			{showWarning && warningText && (
				<CAlert color="warning" className="mb-3">
					{warningText}
				</CAlert>
			)}

			<div className="mb-3 row">
				<CFormLabel htmlFor={labelInputId} className="col-sm-3 col-form-label">
					Image name
				</CFormLabel>
				<div className="col-sm-9">
					<TextInputField
						// id={labelInputId}
						value={value}
						setValue={onChange}
						placeholder={placeholder}
						tooltip={tooltip}
						checkValid={isLabelValid}
						disabled={disabled}
					/>
				</div>
			</div>
			<div className="text-muted small">{helpText || defaultHelpText}</div>
		</>
	)
}
